import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-6" }
const _hoisted_2 = { class: "mb-2 text-lg font-semibold text-neutral-900" }
const _hoisted_3 = { class: "mb-4 text-sm text-neutral-600" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["href"]

import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import ArrowRightIcon from "@/components/icons/arrowRightIcon.vue";
import { computed } from 'vue';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationDetails',
  props: {
    title: {
        type: String,
        default: null,
    },
    date: {
        type: String,
        default: null,
    },
    description: {
        type: String,
        default: null,
    },
    routeLink: {
        type: String,
        default: null,
    },
    buttonText: {
        type: String,
        default: null,
    },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const cleanseUrl = computed(() => {
    const url = props.routeLink.split('https://www.wcpmis.org');
    return url[1] == undefined ? false : true;
});

const redirect = () => {
    const url = props.routeLink.split('https://www.wcpmis.org');
    router.push(url[1]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.date), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", {
        class: "text-sm text-neutral-900",
        innerHTML: __props.description
      }, null, 8, _hoisted_5)
    ]),
    (cleanseUrl.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (redirect()))
        }, [
          _createVNode(ButtonComponent, { size: "large" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(__props.buttonText), 1),
              _createVNode(ArrowRightIcon, { class: "w-5 h-5 ml-2 icon" })
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: __props.routeLink
        }, [
          _createVNode(ButtonComponent, { size: "large" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(__props.buttonText), 1),
              _createVNode(ArrowRightIcon, { class: "w-5 h-5 ml-2 icon" })
            ]),
            _: 1
          })
        ], 8, _hoisted_6))
  ]))
}
}

})